import { render, staticRenderFns } from "./confirmedTripBilling.vue?vue&type=template&id=4ea973dd&"
import script from "./confirmedTripBilling.vue?vue&type=script&lang=js&"
export * from "./confirmedTripBilling.vue?vue&type=script&lang=js&"
import style0 from "./confirmedTripBilling.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "confirmedTripBilling.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {
  VContainer,
  VLayout,
})
